import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Ticket } from "lucide-react";

export const PromoBanner = ({ compact = false }) => {
  const [promo, setPromo] = useState(null);
  useEffect(() => { api.get("/public/promo").then((r) => setPromo(r.data)).catch(() => setPromo({ active: false })); }, []);
  if (!promo?.active) return null;
  const rabatt = promo.percent ? `${promo.percent} %` : `${promo.amount} €`;
  return (
    <div className={`flex items-center gap-3 rounded-xl border border-[#FF5A1F]/40 bg-[#FF5A1F]/10 ${compact ? "px-4 py-2.5 text-sm" : "px-5 py-4"}`} data-testid="promo-banner">
      <Ticket className="w-5 h-5 text-[#FF5A1F] shrink-0" />
      <div className="text-slate-200">
        <span className="font-head font-semibold">Erstkunden sparen {rabatt}</span>
        <span className="text-slate-400"> – Code </span><span className="mono font-bold text-white tracking-wider" data-testid="promo-code">{promo.code}</span>
        <span className="text-slate-400"> im Checkout einlösen.</span>
      </div>
    </div>
  );
};
